<script>

    export let projectUpdateSettings = () => {};
    export let projectSettings;

    import {saveSettings, loadSettings} from '../lib/local-storage';
    import FormField from '@smui/form-field';
    import Slider from '@smui/slider';
    import Accordion, { Panel, Header, Content } from '@smui-extra/accordion';
    import Switch from '@smui/switch';

    let settings = {};
    let minRotation;
    let maxRotation;
    let minScale;
    let maxScale;
    let randomBackground;
    let brightnessMin;
    let brightnessMax;
    let contrastMin;
    let contrastMax;
    let saturationMin;
    let saturationMax;
    let hueRotateMin;
    let hueRotateMax;
    let blur;
    
    const update = () => {
        settings = loadSettings();
        minRotation = settings.output.minRotation;
        maxRotation = settings.output.maxRotation;
        minScale = settings.output.minScale;
        maxScale = settings.output.maxScale;
        randomBackground = settings.output.randomBackground;
        brightnessMin = settings.output.brightnessMin;
        brightnessMax = settings.output.brightnessMax;
        contrastMin = settings.output.contrastMin;
        contrastMax = settings.output.contrastMax;
        saturationMin = settings.output.saturationMin;
        saturationMax = settings.output.saturationMax;
        hueRotateMin = settings.output.hueRotateMin;
        hueRotateMax = settings.output.hueRotateMax;
        blur = settings.output.blur;
    }

    const saveLocalSettings = () => {
        saveSettings(settings)
        if(typeof projectUpdateSettings === 'function') {
            projectUpdateSettings();
        }
    }
    const setRotation = () => {
        settings.output.minRotation = minRotation;
        settings.output.maxRotation = maxRotation;
        saveLocalSettings();
    }
    const setScale = () => {
        settings = loadSettings();
        settings.output.minScale = minScale;
        settings.output.maxScale = maxScale;
        console.log(minScale, maxScale);
        saveLocalSettings();
    }
    const setRandomBackground = () => {
        console.log('sdfdf', randomBackground);
        settings.output.randomBackground = randomBackground;
        saveLocalSettings();
    }
    const setBrightness = () => {
        settings = loadSettings();
        settings.output.brightnessMin = brightnessMin;
        settings.output.brightnessMax = brightnessMax;
        saveLocalSettings();
    }
    const setContrast = () => {
        settings = loadSettings();
        settings.output.contrastMin = contrastMin;
        settings.output.contrastMax = contrastMax;
        saveLocalSettings();
    }
    const setSaturation = () => {
        settings = loadSettings();
        settings.output.saturationMin = saturationMin;
        settings.output.saturationMax = saturationMax;
        saveLocalSettings();
    }
    const setHueRotate = () => {
        settings = loadSettings();
        settings.output.hueRotateMin = hueRotateMin;
        settings.output.hueRotateMax = hueRotateMax;
        saveLocalSettings();
    }
    const setBlur = () => {
        settings = loadSettings();
        settings.output.blur = blur;
        saveLocalSettings();
    }
    update()
    $: [
        update(projectSettings)
    ]
</script>
{#if settings.output}
<Accordion multiple>
    <Panel>
        <Header>
            Rotation
            <span slot="description">From {minRotation}° to {maxRotation}°</span>
        </Header>
      <Content>
       
            <Slider
                range
                on:SMUISlider:input={(e) => setRotation(minRotation, maxRotation)}
                bind:start={minRotation}
                bind:end={maxRotation}
                min={0}
                max={360}
                step={1}
                input$aria-label="Rotation"
            />
        </Content>
    </Panel>
    <Panel>
        <Header>
            Scaling
            <span slot="description">From {minScale}% to {maxScale}%</span>
        </Header>
      <Content>
            <Slider
                range
                on:SMUISlider:input={(e) => setScale(minScale, maxScale)}
                bind:start={minScale}
                bind:end={maxScale}
                min={50}
                max={150}
                step={5}
                input$aria-label="Scale level"
            />
        </Content>
    </Panel>
    <Panel>
        <Header>
            Brightness
            <span slot="description">From {brightnessMin}% to {brightnessMax}%</span>
        </Header>
      <Content>
            <Slider
                range
                on:SMUISlider:input={(e) => setBrightness()}
                bind:start={brightnessMin}
                bind:end={brightnessMax}
                min={10}
                max={190}
                step={10}
                input$aria-label="Brightness level"
            />
        </Content>
    </Panel>
    <Panel>
        <Header>
            Constrast
            <span slot="description">From {contrastMin}% to {contrastMax}%</span>
        </Header>
      <Content>
            <Slider
                range
                on:SMUISlider:input={(e) => setContrast()}
                bind:start={contrastMin}
                bind:end={contrastMax}
                min={10}
                max={190}
                step={10}
                input$aria-label="Contrast level"
            />
        </Content>
    </Panel>
    <Panel>
        <Header>
            Saturation
            <span slot="description">From {saturationMin}% to {saturationMax}%</span>
        </Header>
      <Content>
            <Slider
                range
                on:SMUISlider:input={(e) => setSaturation()}
                bind:start={saturationMax}
                bind:end={saturationMin}
                min={10}
                max={190}
                step={10}
                input$aria-label="Contrast level"
            />
        </Content>
    </Panel>
    <Panel>
        <Header>
            Blur
            <span slot="description">{blur}px</span>
        </Header>
      <Content>
            <Slider
                on:SMUISlider:input={(e) => setBlur()}
                bind:value={blur}
                min={0}
                max={10}
                step={1}
                input$aria-label="Blur level"
            />
        </Content>
    </Panel>
    <Panel>
        <Header>
            Hue Rotation
            <span slot="description">From {hueRotateMin}° to {hueRotateMax}°</span>
        </Header>
      <Content>
            <Slider
                range
                on:SMUISlider:input={(e) => setHueRotate()}
                bind:start={hueRotateMin}
                bind:end={hueRotateMax}
                min={0}
                max={360}
                step={1}
                input$aria-label="Contrast level"
            />
        </Content>
    </Panel>
    <Panel>
        <Header>
            Randomize Position
            <span slot="description">{randomBackground ? 'enabled' : 'disabled'}</span>
        </Header>
      <Content>
        <FormField>
            <Switch bind:checked={randomBackground} on:SMUISwitch:change={setRandomBackground} />
          </FormField>
        </Content>
    </Panel>
  </Accordion>
{/if}